import React from "react";
import {Layout} from 'antd';
import {connect} from 'react-redux';
import {NAV_TYPE_SIDE, SIDE_NAV_DARK, SIDE_NAV_WIDTH} from 'constants/ThemeConstant';
import {Scrollbars} from 'react-custom-scrollbars';
import MenuContent from './MenuContent'
import Logo from './Logo';
import utils from 'utils';

const { Sider } = Layout;

export const SideNav = ({
	navCollapsed,
	sideNavTheme,
	headerNavColor,
	routeInfo,
	hideGroupTitle,
	localization = true,
	currentTheme,
}) => {
	const props = { sideNavTheme, routeInfo, hideGroupTitle, localization };
	const mode = () => {
		if (!headerNavColor) {
			return utils.getColorContrast(
				currentTheme === 'dark' ? '#00000' : '#ffffff'
			);
		}
		return utils.getColorContrast(headerNavColor);
	};
	const navMode = mode();
	return (
		<Sider
			className={`side-nav ${
				sideNavTheme === SIDE_NAV_DARK ? 'side-nav-dark' : ''
			}`}
			width={SIDE_NAV_WIDTH}
			collapsed={navCollapsed}
		>
			<Logo logoType={navMode} className="mb-3" />
			<Scrollbars autoHide>
				<MenuContent type={NAV_TYPE_SIDE} {...props} />
			</Scrollbars>
		</Sider>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, sideNavTheme, headerNavColor, currentTheme } = theme;
	return { navCollapsed, sideNavTheme, headerNavColor, currentTheme };
};

export default connect(mapStateToProps)(SideNav);
